import {ContactsTableController} from "../../../contact/controller/contacts_table/ContactsTableController";
import {Lead} from "../../model/Lead";
import {LeadServiceName} from "../../../utils/names/serviceNames";
import {LoaderStatusValue} from "../../../loader/service/loaderStatus";
import {ToastNotificationService} from "../../../utils/ToastNotificationService";
import {IContactService} from "../../../contact/service/IContactService";

export class LeadsTableComponent extends ContactsTableController<Lead> {

    static instance = ContactsTableController.instanceFactory(LeadServiceName, LeadsTableComponent);

    constructor($scope: any,
                $location: angular.ILocationService,
                $mdDialog: angular.material.IDialogService,
                loader: LoaderStatusValue,
                notificationService: ToastNotificationService,
                contactService: IContactService<Lead>) {
        super($scope, $location, $mdDialog, loader, notificationService, contactService);
    }

    protected profileUrl(id: number) {
        return `/lead_profile/${id}`;
    }

    protected title() {
        return "Leads";
    }

}